import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const usePublicationStore = defineStore("publications", {
  state: () => ({
    publications: [],
    totalPages: 1,
    currentPage: 1,
    totalResults: 0,
    loading: false,
    error: "",
  }),

  actions: {
    /**
     * Obtener listado de publicaciones activas
     */
    async fetchPublications(params = {}) {
      this.loading = true;
      this.error = "";

      try {
        const response = await apiClient.get("/public/publications", {
          params: {
            page: params.page ?? this.currentPage,
          },
        });

        this.publications = response.data.data;
        this.currentPage = Number(response.data.current_page);
        this.totalPages = Number(response.data.last_page);
        this.totalResults = Number(response.data.total);
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar las publicaciones. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Cambiar de página
     */
    async changePage(page) {
      this.currentPage = page;
      await this.fetchPublications();
    },

    /**
     * Resetear store
     */
    resetStore() {
      this.publications = [];
      this.totalPages = 1;
      this.currentPage = 1;
      this.totalResults = 0;
      this.error = "";
    },
  },
});
